import { PlayActionTypes, PlayRomFileAction, StopPlayingAction } from 'app/dux/play/types';

export const playRom = (romId: string): PlayRomFileAction => ({ type: PlayActionTypes.PLAY_ROM_FILE, romId });
export const stopPlayingRom = (): StopPlayingAction => ({ type: PlayActionTypes.STOP_PLAYING });
